import React, { useEffect, useState, useRef } from 'react';
import { useHistory } from 'react-router';
import { isAuthenticated } from '../../../../services/auth';
import { message } from 'antd';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { Autocomplete, TextField } from '@mui/material';
import { getLocation, editLocation, allCities, citiesByState } from '../../../../services/admin';
import UnifiedDashboard from '../../../../components/layout/unified-dashboard';

const EditLocation = ({ match }) => {
  const [name, setName] = useState('');
  const [state, setState] = useState('');
  const [city, setCity] = useState('');
  const [cities, setCities] = useState([]);
  const mountedRef = useRef(true);
  const { token } = isAuthenticated();
  const history = useHistory();

  const BRAZILIAN_STATES = [
    'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA',
    'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN',
    'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'
  ];

  useEffect(() => {
    const loadData = async () => {
      if (match.params.locationId) {
        const data = await getLocation(match.params.locationId);
        setName(data.data.name);
        setState(data.data.city.state || '');
        loadCitiesByState(data.data.city.state || '');
        setCity(data.data.city._id || '');
      }
    };

    loadData();
  }, [match.params.locationId]);

  useEffect(() => {
    if (state) {
      loadCitiesByState(state);
      setCity(''); // Reset city when state changes
    } else {
      setCities([]);
      setCity(''); // Reset city when no state
    }
  }, [state]);

  const loadCitiesByState = async (selectedState) => {
    try {
      console.log('Buscando cidades para o estado:', selectedState);
      const citiesRes = await citiesByState(selectedState);
      console.log('Cidades recebidas:', citiesRes.data);
      if (citiesRes.status === 200 && mountedRef.current) {
        setCities(citiesRes.data);
      }
    } catch (error) {
      console.error('Erro ao buscar cidades:', error);
      if (mountedRef.current) {
        setCities([]);
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (!name || !city) {
        message.error('Nome e cidade são obrigatórios');
        return;
      }
      await editLocation(match.params.locationId, { name, city, token });
      message.success('Localização editada com sucesso', 4);
      history.push('/admin/add-location');
    } catch (err) {
      if (err.response?.status === 400) message.error(err.response.data, 4);
    }
  };

  return (
    <UnifiedDashboard title="Editar Localização">
      <div className='edit-location-container'>
        <div className='edit-location-header'>
          <button
            className='edit-location-back-btn'
            onClick={() => history.push('/admin/add-location')}
            title='Voltar'
          >
            <ArrowBackIcon />
          </button>
          <div>
            <h1 className='edit-location-title'>
              <i className='fas fa-edit'></i>
              Editar Localização
            </h1>
            <p className='edit-location-subtitle'>Altere os dados da localização</p>
          </div>
        </div>

        <div className='edit-location-card'>
          <form onSubmit={handleSubmit} className='edit-location-form'>
            <div className='edit-location-form-group'>
              <label className='edit-location-label'>
                <i className='fas fa-flag'></i>
                Estado
              </label>
              <Autocomplete
                options={BRAZILIAN_STATES}
                value={state}
                onChange={(event, newValue) => {
                  setState(newValue || '');
                }}
                renderInput={(params) => <TextField {...params} className='edit-location-input' required />}
                disableClearable
              />
            </div>

            <div className='edit-location-form-group'>
              <label className='edit-location-label'>
                <i className='fas fa-flag'></i>
                Cidade
              </label>
              <Autocomplete
                options={cities}
                getOptionLabel={(option) => option.name || ''}
                isOptionEqualToValue={(option, value) => option._id === value._id}
                value={cities.find(c => c._id === city) || null}
                onChange={(event, newValue) => setCity(newValue ? newValue._id : '')}
                disabled={!state}
                renderInput={(params) => <TextField {...params} className='edit-location-input' required />}
                renderOption={(props, option) => (
                  <li {...props} key={option._id}>
                    {option.name}
                  </li>
                )}
                noOptionsText="Nenhuma cidade encontrada"
                loadingText="Carregando..."
              />
            </div>

            <div className='edit-location-form-group'>
              <label className='edit-location-label'>
                <i className='fas fa-map-pin'></i>
                Nome da Localização
              </label>
              <input
                type='text'
                className='edit-location-input'
                placeholder='Digite o novo nome da localização'
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>
            <button type='submit' className='edit-location-submit-btn'>
              <i className='fas fa-save'></i>
              Salvar Alterações
            </button>
          </form>
        </div>
      </div>
    </UnifiedDashboard>
  );
};

export default EditLocation;
